module.exports = __webpack_public_path__ + "static/media/add_data.d7d0494e.svg";